import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.936 8a7.064 7.064 0 1 1 14.128 0A7.064 7.064 0 0 1 .936 8ZM8 1.949a6.051 6.051 0 0 0-4.472 10.127A5.303 5.303 0 0 1 8 9.626c1.88 0 3.53.978 4.473 2.45A6.051 6.051 0 0 0 8 1.948Zm3.714 10.828A4.291 4.291 0 0 0 8 10.64c-1.584 0-2.97.858-3.714 2.138A6.024 6.024 0 0 0 8 14.05c1.4 0 2.689-.476 3.714-1.274ZM5.494 6.94a2.507 2.507 0 1 1 5.013 0 2.507 2.507 0 0 1-5.014 0ZM8 5.445a1.493 1.493 0 1 0 0 2.987 1.493 1.493 0 0 0 0-2.987Z"
      clipRule="evenodd"
    />
  </svg>
);

export { SvgComponent as UserCircleIcon };

